export const findSubModuleAccess = (productAccess, moduleName, screen) => {
  const submodule = productAccess
    ?.find((module) => module?.module_name === moduleName)
    ?.submodules?.find((sub) => sub?.sub_module_name === screen);
  return !!submodule;
};

export const checkViewerPermission = (productAccess, moduleName, screen) => {
  const mod = productAccess?.find((m) => m?.module_name === moduleName);
  const sub = mod && mod?.submodules.find((s) => s?.sub_module_name === screen);
  return sub && sub?.permissions?.viewer === true;
};

export const checkEditorPermission = (productAccess, moduleName, screen) => {
  const mod = productAccess?.find((m) => m?.module_name === moduleName);
  const sub = mod && mod?.submodules.find((s) => s?.sub_module_name === screen);
  return sub && sub?.permissions?.editor === true;
};

export const checkFirstLevelApproverPermission = (
  productAccess,
  moduleName,
  screen
) => {
  const mod = productAccess?.find((m) => m?.module_name === moduleName);
  const sub = mod && mod?.submodules.find((s) => s?.sub_module_name === screen);
  return sub && sub?.permissions?.first_level_approver === true;
};

export const checkSecondLevelApproverPermission = (
  productAccess,
  moduleName,
  screen
) => {
  const mod = productAccess?.find((m) => m?.module_name === moduleName);
  const sub = mod && mod?.submodules.find((s) => s?.sub_module_name === screen);
  return sub && sub?.permissions?.second_level_approver === true;
};
